import { render, staticRenderFns } from "./QuizComponent.vue?vue&type=template&id=2076f18e&scoped=true"
import script from "./QuizComponent.vue?vue&type=script&lang=js"
export * from "./QuizComponent.vue?vue&type=script&lang=js"
import style0 from "./QuizComponent.vue?vue&type=style&index=0&id=2076f18e&prod&lang=scss&scoped=true"
import style1 from "./QuizComponent.vue?vue&type=style&index=1&id=2076f18e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2076f18e",
  null
  
)

export default component.exports